
import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "reactstrap";

class AuthHeader extends React.Component {
  render() {
    return (
      <>
        <div className="header pt-lg-7">
          <Container>
            <div className="header-body text-center mb-4">
              <Row className="justify-content-center">
                <Col className="px-5" lg="8" md="8" xl="8">
                  {this.props.title ? (
                    <h1 className="text-white">{this.props.title}</h1>
                  ) : null}
                  {this.props.lead ? (
                    <p style={{textShadow: `-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black`}} className="h3 text-white">{this.props.lead}</p>
                  ) : null}
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

AuthHeader.propTypes = {
  title: PropTypes.string,
  lead: PropTypes.string
};

export default AuthHeader;
